import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ApiError } from "src/api/axiosClient/types";
import { RootState } from "src/store";
import { GetAdminPlansParams, Plan } from "../types";
import { PlansState } from "./types";

const initialState: PlansState = {
  loading: {
    getList: false,
    create: false,
    update: false,
    archive: false,
    unarchive: false,
  },
  filter: {
    applicationId: "",
    offset: 0,
    limit: 25,
    page: 0,
  },
  list: null,
  error: null,
};

const plansSlice = createSlice({
  name: "plans",
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<Partial<Record<keyof PlansState["loading"], boolean>>>) => {
      state.loading = { ...state.loading, ...action.payload };
    },
    setFilter(state, action: PayloadAction<Partial<GetAdminPlansParams>>) {
      state.filter = {
        ...state.filter,
        ...action.payload,
      };
    },
    setList: (
      state,
      action: PayloadAction<{
        items: Plan[];
        count: number;
      }>
    ) => {
      state.list = action.payload;
    },
    setError: (state, action: PayloadAction<ApiError>) => {
      state.error = action.payload;
    },
    resetList: (state) => {
      state.filter = initialState.filter;
      state.list = initialState.list;
    },
    resetError: (state) => {
      state.error = initialState.error;
    },
    resetSlice: () => {
      initialState;
    },
  },
});

export const isPlansLoading = (state: RootState) => state.plans.loading;

export const getPlans = (state: RootState) => state.plans.list;

export const isPlansError = (state: RootState) => state.plans.error;

export const { setLoading, setFilter, setList, setError, resetList, resetError, resetSlice } = plansSlice.actions;

export const plansReducer = plansSlice.reducer;
